import React, { useEffect, useState, useRef } from "react";
import {
  Grid,
  Box,
  Button,
  Checkbox,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
  InputLabel,
  FormControl,
  MenuItem,
  Select,
  TextField,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Pagination,
  PaginationItem,
  Divider,
  SelectChangeEvent,
  InputAdornment,
} from "@mui/material";
import {
  Add,
  Delete,
  Download,
  FilterList,
  MoreVert,
  Search,
  Clear,
  FirstPage,
  LastPage,
  Remove,
  CloudUpload,
  Close,
  PhotoCamera,
} from "@mui/icons-material";
import { TrashOutline } from "react-ionicons";
import "../../../shared/components/Item.css";
import { styled } from "@mui/system";
import ImageIcon from "@mui/icons-material/Image";
import CloseIcon from "@mui/icons-material/Close";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import FormHelperText from "@mui/material/FormHelperText";
import { LocalizationProvider, DesktopDatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import {
  roleSearchParams,
  createRole,
  deleteRole,
  getPermissionOptions,
  getPermissionLabel,
  assignPermissionsToRole,
  getAllRoles,
  getRoles,
  getRolePermissions,
  updateRolePermission,
  updateRole,
  fetchRoleDetails,
  removePermissionFromRole,
} from "../services/roleService.tsx";
import Swal from "sweetalert2";
import * as XLSX from "xlsx";

// Dummy Data
const initialRows = Array.from({ length: 50 }, (_, index) => ({
  id: index,
  boldText: "Bold text column",
  textColumn1: "Regular text column",
  textColumn2: "Regular text column",
}));

interface AdvancedSearchDialogProps {
  open: boolean;
  onClose: () => void;
  onSearchResults: (results: Role[]) => void;
}

interface Role {
  roleName: string;
  description: string;
}

const RoleListPage: React.FC = () => {
  const [selectedRows, setSelectedRows] = useState<number[]>([]);
  const [showSearch, setShowSearch] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [rows, setRows] = useState<any[]>([]);
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [openAddRoleDialog, setOpenAddRoleDialog] = useState(false);
  const [openEditRoleDialog, setOpenEditRoleDialog] = useState(false);
  const [openFilterDialog, setOpenFilterDialog] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState("");
  const [permissionSearch, setPermissionSearch] = React.useState("");
  const [rowsPerPage, setRowsPerPage] = useState(10); // Jumlah item per halaman
  const [totalItems, setTotalItems] = useState(0); // Total semua data
  const [currentPage, setCurrentPage] = useState(1); // Halaman aktif
  const [totalPages, setTotalPages] = useState(1); // Total halaman

  // Fungsi untuk mengambil data karyawan

  // Role Data Table ========================================================================
  // Fungsi untuk mengambil data karyawan
  const reloadRole = async () => {
    setIsLoading(true);
    setError(""); // Reset error before reloading data
    try {
      const result = await getRoles({
        ...filterParams, // ← nanti kamu tinggal simpan filter dari search input di state ini
        limit: rowsPerPage,
        offset,
        orderBy: sortConfig.orderBy,
        order: sortConfig.order,
      });
      setRows(
        result.data.map((role) => ({
          id: role.id,
          boldText: role.name, // Role name will be bold
          textColumn1: role.description, // Description in regular text
          textColumn2: "", // Empty for the third column
        }))
      );
      setTotalItems(result.total);
      // Since we're not paginating here, set total pages to 1
      setTotalPages(result.pagination.totalPages);
    } catch (err: any) {
      setError(err.message);
    } finally {
      setIsLoading(false);
    }
  };

  const offset = (currentPage - 1) * rowsPerPage;

  const [filterParams, setFilterParams] = useState<{
    name?: string;
    description?: string;
    menuName?: string;
    permissionName?: string;
    keyword?: string;
  }>({});

  // Sort
  const [sortConfig, setSortConfig] = useState<{
    orderBy: string;
    order: "asc" | "desc";
  }>({
    orderBy: "createdAt",
    order: "desc",
  });

  const handleSort = (column: string) => {
    setSortConfig((prev) => {
      if (prev.orderBy === column) {
        return {
          orderBy: column,
          order: prev.order === "asc" ? "desc" : "asc",
        };
      } else {
        return {
          orderBy: column,
          order: "asc",
        };
      }
    });
    setCurrentPage(1); // reset ke halaman 1 saat sort berubah
  };

  // Fungsi untuk menangani pemilihan checkbox baris
  const handleSelectRow = (id: number) => {
    setSelectedRows((prev) =>
      prev.includes(id) ? prev.filter((rowId) => rowId !== id) : [...prev, id]
    );
  };

  const CustomTextField = styled(TextField)({
    "& .MuiInputBase-input": {
      backgroundColor: "#f5f5f5",
      borderRadius: 4,
      padding: "8px 12px",
    },
  });

  const handleDeleteRole = async () => {
    if (!selectedRole) return;

    const confirmDelete = await Swal.fire({
      title: "Apakah Anda yakin?",
      text: "Anda tidak dapat mengembalikan data yang dihapus!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Ya, hapus!",
      cancelButtonText: "Batal",
    });

    if (!confirmDelete.isConfirmed) return;

    try {
      await deleteRole(String(selectedRole.name));
      // Rest of your delete logic
    } catch (error: any) {
      // Error handling
    }
  };

  // 🔄 Pastikan selectedRows update setelah rows berubah
  useEffect(() => {
    setSelectedRows([]);
  }, [rows]);

  const [filters, setFilters] = useState([{ field: "name", value: "" }]);
  const [roles, setRoles] = useState<Role[]>([]);

  // Daftar pilihan filter yang tersedia
  const availableFilters = [
    { value: "name", label: "Role Name" },
    { value: "description", label: "Role Description" },
  ];

  // FILTER

  const handleFilterChange = (index: number, key: string, value: string) => {
    const newFilters = [...filters];
    newFilters[index][key] = value;
    setFilters(newFilters);
  };

  const handleAddFilter = () => {
    setFilters([...filters, { field: "", value: "" }]);
  };

  const handleRemoveFilter = (index: number) => {
    setFilters(filters.filter((_, i) => i !== index));
  };

  const handleApplyFilters = async () => {
    setIsLoading(true);
    try {
      // Buat object parameter pencarian sesuai `ItemSearchParams`
      const searchParams: roleSearchParams = {};

      filters.forEach((filter) => {
        if (filter.value.trim() !== "") {
          searchParams[filter.field] = filter.value;
        }
      });

      // // Panggil fungsi pencarian dari itemServices.tsx
      // const response = await getItems(searchParams);
      // console.log(response);
      // // Format hasil pencarian sebelum ditampilkan di tabel
      // handleSearchResults(response.data);

      setFilterParams(searchParams);
      setOpenFilterDialog(false);
    } catch (error) {
      console.error("Error fetching data:", error);
      Swal.fire({
        icon: "error",
        title: "Gagal mengambil data",
        text: error.response?.data?.message || "Terjadi kesalahan",
      });
      handleCloseFilter();
    } finally {
      setIsLoading(false);
    }
  };

  // ✅ Tambahkan fungsi ini
  const handleSearchResults = (results) => {
    setRows(results); // Update rows agar sesuai dengan format tabel
    setOpenFilterDialog(false); // Tutup dialog setelah apply filter
  };

  const handleCloseFilter = () => {
    setOpenFilterDialog(false);
  };

  const handleResetFilters = () => {
    setFilters([{ field: "name", value: "" }]); // Reset ke kondisi awal dengan satu filter kosong
  };

  //======================= Search ===================================
  const handleSearch = async () => {
    // if (searchQuery.trim() === "") return; // Hindari pencarian kosong
    setIsLoading(true);
    setError("");

    try {
      // const results = await getRoles({
      //   keyword: searchQuery,
      //   limit: rowsPerPage,
      //   offset,
      // });
      setFilterParams({
        keyword: searchQuery,
      });
    } catch (err) {
      setError(err);
    } finally {
      setIsLoading(false);
    }
  };

  const handleExport = async () => {
    try {
      // Show loading indicator
      Swal.fire({
        title: "Preparing Export...",
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });

      // Get all roles with their permissions
      const allRoles = await getRoles({
        ...filterParams,
        limit: 10000, // Get all data
        offset: 0,
        orderBy: sortConfig.orderBy,
        order: sortConfig.order,
        includePermissions: true, // Make sure your API supports this
      });

      const formatTimestampz = (
        timestamp: string | Date | null,
        withTime: boolean = true
      ): string => {
        if (!timestamp) return "-";

        const date = new Date(timestamp);

        if (isNaN(date.getTime())) return "Invalid Date";

        // Format tanggal: DD/MM/YYYY
        const day = String(date.getDate()).padStart(2, "0");
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const year = date.getFullYear();
        const datePart = `${day}/${month}/${year}`;

        if (!withTime) return datePart;

        // Format waktu: HH:MM:SS
        const hours = String(date.getHours()).padStart(2, "0");
        const minutes = String(date.getMinutes()).padStart(2, "0");
        const seconds = String(date.getSeconds()).padStart(2, "0");
        const timePart = `${hours}:${minutes}:${seconds}`;

        return `${datePart} ${timePart}`;
      };

      // Format the data for export
      const exportData = await Promise.all(
        allRoles.data.map(async (role) => {
          // Get permissions for this role
          let permissions: string[] = [];
          try {
            const permissionResponse = await getRolePermissions(role.name);
            permissions = permissionResponse.permissions || [];
          } catch (error) {
            console.error(
              `Failed to get permissions for role ${role.name}:`,
              error
            );
            permissions = ["Error loading permissions"];
          }

          // Format permissions for display
          const formattedPermissions = permissions
            .map((permissionName) => {
              const permission = permissionOptions.find(
                (p) => p.name === permissionName
              );
              return permission?.label || permissionName;
            })
            .join(", ");

          return {
            "Role Name": role.name || "-",
            "Role Description": role.description || "-",
            Permissions: formattedPermissions || "No permissions",
            "Permission Count": permissions.length,
            "Tanggal Dibuat": formatTimestampz(role.createdAt) || "-",
            "Tanggal Diupdate": formatTimestampz(role.updateAt) || "-",
          };
        })
      );

      // Create worksheet
      const ws = XLSX.utils.json_to_sheet(exportData);

      // Create workbook
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Roles");

      // Generate Excel file
      const date = new Date().toISOString().slice(0, 10);
      XLSX.writeFile(wb, `Roles_with_Permissions_${date}.xlsx`);

      // Close loading
      Swal.close();
    } catch (error) {
      console.error("Export failed:", error);
      Swal.fire({
        icon: "error",
        title: "Export Failed",
        text: error.message || "Failed to export role data",
      });
    }
  };

  // Fungsi untuk memformat data karyawan untuk export
  const formatRoleForExport = (role) => ({
    "Role Name": role.name,
    "Role Description": role.description,
    "Role Permission": role.permission,
    // ... tambahkan field lainnya sesuai kebutuhan
  });

  // add role data ========================================================================
  // State untuk form dengan TypeScript interface
  interface RoleData {
    roleName: string;
    description: string;
    permissions: string[]; // This stores permission IDs
  }

  // Tambahkan interface untuk PermissionOption
  interface PermissionOption {
    value: string; // Permission ID
    label: string; // Human-readable name (e.g., "Create User")
    name: string; // Original API name (e.g., "CREATE_USER")
  }

  const [roleDataAdd, setRoleDataAdd] = useState<RoleData>({
    roleName: "",
    description: "",
    permissions: [],
  });

  const resetAddDialog = () => {
    setRoleDataAdd({
      roleName: "",
      description: "",
      permissions: [],
    });
    setNewPermission("");
  };

  const handleOpenAddDialog = () => {
    resetAddDialog();
    setOpenAddRoleDialog(true);
  };

  const [permissionOptions, setPermissionOptions] = useState<
    PermissionOption[]
  >([]);
  const [newPermission, setNewPermission] = useState<string>("");
  const [permissionLabels, setPermissionLabels] = useState<
    Record<string, string>
  >({});

  // Di dalam komponen RoleListPage, tambahkan useEffect ini:
  const [loadingPermissions, setLoadingPermissions] = useState(false);
  const [addingPermission, setAddingPermission] = useState(false);

  // Fungsi untuk menampilkan label permission
  const displayPermissionLabel = async (value: string) => {
    return await getPermissionLabel(value);
  };

  // Handler untuk select permission
  const handlePermissionSelect = (e: SelectChangeEvent<string>) => {
    setNewPermission(e.target.value);
  };

  // Fungsi untuk menambah permission
  const handleAddPermission = () => {
    if (!newPermission) {
      console.warn("No permission selected");
      return;
    }

    // Pastikan permission belum ada
    if (!roleDataAdd.permissions.includes(newPermission)) {
      setRoleDataAdd((prev) => ({
        ...prev,
        permissions: [...prev.permissions, newPermission],
      }));
      setNewPermission(""); // Reset selection
    } else {
      console.warn("Permission already added");
    }
  };

  // Fungsi untuk menghapus permission
  const handleRemovePermission = (index) => {
    const updatedPermissions = [...roleDataAdd.permissions];
    updatedPermissions.splice(index, 1);
    setRoleDataAdd({
      ...roleDataAdd,
      permissions: updatedPermissions,
    });
  };

  // Fungsi untuk handle perubahan input lainnya
  const handleInputChangeAdd = (e) => {
    const { name, value } = e.target;
    setRoleDataAdd({
      ...roleDataAdd,
      [name]: value,
    });
  };

  const [errorsAdd, setErrorsAdd] = useState({
    roleName: false,
    permissions: false,
  });

  const validateFormAdd = () => {
    let newErrors = {
      roleName: !roleDataAdd.roleName,
      permissions: !roleDataAdd.permissions,
    };
    setErrorsAdd(newErrors);
    return !Object.values(newErrors).includes(true);
  };

  const showPopupMandatoryError = () => {
    Swal.fire({
      icon: "error",
      title: "Data Belum Lengkap",
      text: "Lengkapi data yang wajib diisi.",
    });
  };

  const handleSaveAdd = async () => {
    try {
      if (!validateFormAdd()) {
        showPopupMandatoryError();
        return;
      }

      // Validate required fields
      if (!roleDataAdd?.roleName) {
        Swal.fire({
          icon: "error",
          title: "Validation Error",
          text: "Role name is required",
        });
        return;
      }

      if (!roleDataAdd.permissions || roleDataAdd.permissions.length === 0) {
        Swal.fire({
          icon: "warning",
          title: "Role Required",
          text: "Please select at least one role for the employee",
          confirmButtonColor: "#0F62FE",
        });
        return;
      }

      // Step 1: Create the role
      const createResponse = await createRole({
        roleName: roleDataAdd.roleName,
        description: roleDataAdd.description || "",
      });

      // Step 2: Convert permission IDs to permission names
      const permissionNames = (roleDataAdd.permissions || [])
        .map((permissionId) => {
          const permission = (permissionOptions || []).find(
            (p) => p.value === permissionId
          );
          return permission?.name;
        })
        .filter(Boolean) as string[];

      // Step 3: Assign permissions if any
      if (permissionNames.length > 0 && createResponse?.role?.name) {
        await assignPermissionsToRole(
          createResponse.role.name,
          permissionNames
        );
      }

      // Show success message
      Swal.fire({
        icon: "success",
        title: "Role created successfully",
        text:
          permissionNames.length > 0
            ? "Role and permissions assigned successfully"
            : "Role created (no permissions assigned)",
        confirmButtonColor: "#0F62FE",
      });

      setOpenAddRoleDialog(false);
      reloadRole();
    } catch (error: any) {
      console.error("Error creating role:", error);

      // Handle duplicate error specifically
      if (
        error?.response?.data?.error === "Duplicate values for unique fields"
      ) {
        const duplicates = error.response.data.duplicates || [];
        const duplicateFields = duplicates.map((d: any) => ({
          field: d.field || "field",
          value: d.value || "value",
        }));

        let errorMessage = "Cannot create role because:<br><ul>";
        duplicateFields.forEach((df: any) => {
          errorMessage += `<li><strong>${df.field}</strong> with value "${df.value}" already exists</li>`;
        });
        errorMessage += "</ul>Please use different values.";

        Swal.fire({
          icon: "error",
          title: "Duplicate Data Error",
          html: errorMessage,
          confirmButtonColor: "#0F62FE",
        });
        return;
      } else {
        // Handle other errors
        const errorMessage =
          error?.response?.data?.message ||
          error?.message ||
          "Unknown error occurred while creating role";

        Swal.fire({
          icon: "error",
          title: "Error Creating Role",
          html: errorMessage.includes("assign")
            ? `Role was created but failed to assign permissions.<br><small>${errorMessage}</small>`
            : errorMessage,
          confirmButtonColor: "#0F62FE",
        });
      }
    }
  };

  const handleCloseAdd = () => {
    setOpenAddRoleDialog(false);
    resetAddDialog(); // Clear form when closing
    setPermissionSearch(""); // Reset pencarian
    setNewPermission(""); // Reset permission yang dipilih
  };

  useEffect(() => {
    const loadPermissionOptions = async () => {
      setLoadingPermissions(true);
      try {
        const options = await getPermissionOptions();
        setPermissionOptions(options);
      } catch (error) {
        console.error("Failed to load permission options:", error);
        setPermissionOptions([]);
      } finally {
        setLoadingPermissions(false);
      }
    };

    loadPermissionOptions();
  }, []);

  // Update permission labels saat permissionOptions atau selected permissions berubah
  useEffect(() => {
    const labels: Record<string, string> = {};
    permissionOptions.forEach((option) => {
      labels[option.value] = option.label;
    });
    setPermissionLabels(labels);
  }, [permissionOptions]);

  useEffect(() => {
    // Validasi saat newPermission berubah
    if (
      newPermission &&
      !permissionOptions.some((p) => p.value === newPermission)
    ) {
      console.warn("Invalid permission selected:", newPermission);
      setNewPermission("");
    }
  }, [newPermission, permissionOptions]);

  useEffect(() => {
    console.log("Current selected permission:", newPermission);
    console.log("Current permissions:", roleDataAdd.permissions);
    console.log("Available options:", permissionOptions);
  }, [newPermission, roleDataAdd.permissions, permissionOptions]);

  //edit role data ========================================================================
  const [isEditing, setIsEditing] = useState(false);

  const [selectedRoleId, setSelectedRoleId] = useState<number | null>(null);
  const [selectedRole, setSelectedRole] = useState<{ name: string } | null>(
    null
  );

  const [permissionSearchEdit, setPermissionSearchEdit] = React.useState("");

  // Update the state for edit dialog
  const [roleDataEdit, setRoleDataEdit] = useState<RoleData>({
    roleName: "",
    description: "",
    permissions: [],
  });

  const handleOpenEditDialog = async (roleName: string) => {
    setIsLoading(true);
    try {
      const roleDetails = await fetchRoleDetails(roleName);

      // Convert permission names to IDs
      const permissionIds = roleDetails.permissions.map((permissionName) => {
        const permission = permissionOptions.find(
          (p) => p.name === permissionName
        );
        return permission?.value || permissionName;
      });

      setRoleDataEdit({
        roleName: roleDataEdit.roleName,
        description: roleDataEdit.description,
        permissions: permissionIds,
      });

      setSelectedRole({ name: roleName });
      setOpenEditRoleDialog(true);
    } catch (error) {
      console.error("Failed to fetch role data:", error);
      Swal.fire({
        icon: "error",
        title: "Failed to load role",
        text: error instanceof Error ? error.message : "Unknown error occurred",
      });
    } finally {
      setIsLoading(false);
    }
  };

  const [errorsEdit, setErrorsEdit] = useState({
    permissions: false,
  });

  const validateFormEdit = () => {
    // Validasi hanya untuk permission (harus array dan tidak kosong)
    const isValid =
      Array.isArray(roleDataEdit.permissions) &&
      roleDataEdit.permissions.length > 0;

    setErrorsEdit({
      permissions: !isValid,
    });

    return isValid;
  };

  const showPopupMandatoryEditError = () => {
    Swal.fire({
      icon: "error",
      title: "Incomplete Data",
      html: `
        <div>
          <p>Please select at least one permission</p>
          <ul>
            ${errorsEdit.permissions ? "<li>Permissions are required</li>" : ""}
          </ul>
        </div>
      `,
      confirmButtonText: "OK",
      confirmButtonColor: "#0F62FE",
    });
  };

  const handleSaveEdit = async () => {
    try {
      // 1. Validasi form terlebih dahulu
      if (!validateFormEdit()) {
        showPopupMandatoryEditError();
        return;
      }

      if (!selectedRole) {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "No role selected",
        });
        return;
      }

      // 2. Pastikan permissionOptions terisi
      if (!permissionOptions || permissionOptions.length === 0) {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Permission options not loaded",
        });
        return;
      }

      // 3. Validasi roleDataEdit.permissions
      if (
        !roleDataEdit.permissions ||
        !Array.isArray(roleDataEdit.permissions)
      ) {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Invalid permissions data",
        });
        return;
      }

      // 4. Get current permissions
      const currentPermissions = await getRolePermissions(selectedRole.name);
      const currentPermissionNames = currentPermissions.permissions || [];

      // 5. Convert permission IDs to names dengan error handling
      const updatedPermissionNames = roleDataEdit.permissions.map(
        (permissionId) => {
          const permission = permissionOptions.find(
            (p) => p.value === permissionId
          );
          if (!permission) {
            throw new Error(`Permission with ID ${permissionId} not found`);
          }
          return permission.name;
        }
      );

      // 6. Check if permissions are the same (order insensitive)
      const permissionsSame =
        currentPermissionNames.length === updatedPermissionNames.length &&
        currentPermissionNames.every((perm) =>
          updatedPermissionNames.includes(perm)
        );

      if (permissionsSame) {
        Swal.fire({
          icon: "info",
          title: "No Changes",
          text: "Role permissions are identical to current data",
        });
        setOpenEditRoleDialog(false);
        reloadRole();
        return;
      }

      // 7. Process permission changes
      const permissionsToRemove = currentPermissionNames.filter(
        (name) => !updatedPermissionNames.includes(name)
      );
      const permissionsToAdd = updatedPermissionNames.filter(
        (name) => !currentPermissionNames.includes(name)
      );

      // 8. Execute all updates in parallel
      const updatePromises: Promise<any>[] = [];

      // Remove old permissions
      for (const permissionName of permissionsToRemove) {
        updatePromises.push(
          removePermissionFromRole(selectedRole.name, permissionName)
        );
      }

      // Add new permissions
      if (permissionsToAdd.length > 0) {
        updatePromises.push(
          assignPermissionsToRole(selectedRole.name, permissionsToAdd)
        );
      }

      await Promise.all(updatePromises);

      // 9. Success handling
      Swal.fire({
        icon: "success",
        title: "Success",
        text: "Role permissions updated successfully",
        confirmButtonColor: "#0F62FE",
      });

      setOpenEditRoleDialog(false);
      reloadRole();
    } catch (error) {
      console.error("Error updating role permissions:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: error.message || "Failed to update role permissions",
      });
    }
  };

  const handleRemovePermissionEdit = (index: number) => {
    const updatedPermissions = [...roleDataEdit.permissions];
    updatedPermissions.splice(index, 1);
    setRoleDataEdit({
      ...roleDataEdit,
      permissions: updatedPermissions,
    });
  };

  const handleEditPermission = () => {
    if (!newPermission) {
      console.warn("No permission selected");
      return;
    }

    // Pastikan permission belum ada
    if (!roleDataEdit.permissions.includes(newPermission)) {
      setRoleDataEdit((prev) => ({
        ...prev,
        permissions: [...prev.permissions, newPermission],
      }));
      setNewPermission(""); // Reset selection
    } else {
      console.warn("Permission already added");
    }
  };

  const getStatusClass = (status: string) => {
    switch (status) {
      case "Resign":
        return "statusRed";
      case "Probation":
        return "statusGray";
      case "Active":
        return "statusGreen";
      default:
        return "";
    }
  };

  const handleChangeEdit = (event) => {
    setRoleDataEdit(event.target.value);
  };

  const handleInputChangeEdit = (
    event:
      | React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
      | SelectChangeEvent<string>
  ) => {
    const { name, value } = event.target;

    setRoleDataEdit((prevData) => ({
      ...prevData,
      [name]: value,
    }));

    console.log("Updated Role Data:", name, value); // Debugging
  };

  const handleCloseEdit = () => {
    setOpenEditRoleDialog(false);
    setIsEditing(false); // Reset edit mode
    setSelectedRole(null);
    setPermissionSearch(""); // Reset pencarian
    setNewPermission(""); // Reset permission yang dipilih
  };

  const handleFileChangeEdit = (event) => {
    setRoleDataEdit((prevData) => ({
      ...prevData,
      file: event.target.files[0],
    }));
  };

  // Update the handleRowClick function to fetch role details
  const handleRowClick = async (event: React.MouseEvent, roleName: string) => {
    if ((event.target as HTMLElement).closest("input[type='checkbox']")) {
      return;
    }

    setSelectedRole({ name: roleName });
    setOpenEditRoleDialog(true);
  };

  // Update the handleFetchRole function
  const handleFetchRole = async (roleName: string) => {
    setIsLoading(true);
    try {
      const roleDetails = await fetchRoleDetails(roleName);

      // Convert permission names to permission IDs if needed
      const permissionIds = roleDetails.permissions.map((permissionName) => {
        const permission = permissionOptions.find(
          (p) => p.name === permissionName
        );
        return permission?.value || permissionName;
      });

      setRoleDataEdit({
        ...roleDetails,
        permissions: permissionIds, // Use IDs for internal state
      });
    } catch (error) {
      console.error("Failed to fetch role data:", error);
      Swal.fire({
        icon: "error",
        title: "Failed to load role details",
        text: error instanceof Error ? error.message : "Unknown error occurred",
      });
    } finally {
      setIsLoading(false);
    }
  };

  // Update the permission select and add functionality
  const handlePermissionSelectEdit = (e: SelectChangeEvent<string>) => {
    setNewPermission(e.target.value);
  };

  const handleAddPermissionEdit = () => {
    if (!newPermission) {
      console.warn("No permission selected");
      return;
    }

    // Check if permission already exists
    if (!roleDataEdit.permissions.includes(newPermission)) {
      setRoleDataEdit((prev) => ({
        ...prev,
        permissions: [...prev.permissions, newPermission],
      }));
      setNewPermission("");
    } else {
      Swal.fire({
        icon: "warning",
        title: "Permission Exists",
        text: "This permission is already assigned to the role",
      });
    }
  };

  useEffect(() => {
    if (openEditRoleDialog && selectedRole) {
      handleFetchRole(selectedRole.name);
    }
  }, [openEditRoleDialog, selectedRole]);

  // Memanggil data saat komponen pertama kali dimuat
  useEffect(() => {
    reloadRole();
  }, [currentPage, rowsPerPage, filterParams, sortConfig]);

  useEffect(() => {
    const loadPermissionLabels = async () => {
      const labels: Record<string, string> = {};
      for (const option of permissionOptions) {
        labels[option.value] = option.label;
      }
      setPermissionLabels(labels);
    };
    loadPermissionLabels();
  }, [permissionOptions]);

  // ======================================== end of function ========================================================
  // ============================================ start ui ===========================================================

  return (
    <Box sx={{ padding: 3 }}>
      {/* Header & Tabs */}
      <Box
        sx={{ display: "flex", alignItems: "center", gap: 2, marginBottom: 2 }}
      >
        <Typography variant="h6" fontWeight="bold">
          Role List
        </Typography>
      </Box>

      {/* Toolbar */}
      <Box className="toolbar">
        {/* Left Controls */}
        <Box className="leftControls">
          <Typography>Show</Typography>
          <Select
            value={rowsPerPage}
            onChange={(e) => {
              setRowsPerPage(Number(e.target.value));
              setCurrentPage(1); // reset ke halaman 1 saat ganti limit
            }}
            size="small"
          >
            <MenuItem value={10}>10</MenuItem>
            <MenuItem value={25}>25</MenuItem>
            <MenuItem value={50}>50</MenuItem>
          </Select>

          {/* Search Button & Input */}
          <Button
            variant="contained"
            startIcon={<Search />}
            onClick={() => setShowSearch((prev) => !prev)}
            className="searchButton"
          >
            Search
          </Button>
          {showSearch && (
            <TextField
              variant="outlined"
              size="small"
              placeholder="Search"
              value={searchQuery}
              onChange={async (e) => {
                await setSearchQuery(e.target.value);
              }}
              onKeyPress={(e) => e.key === "Enter" && handleSearch()} // Pencarian dengan Enter
              autoFocus
              className="searchInput"
            />
          )}

          {/* Menampilkan Error */}
          {error && <p style={{ color: "red" }}>{error}</p>}
        </Box>

        {/* Right Controls */}
        <Box className="rightControls">
          {/* <Button
            startIcon={<Delete />}
            variant="text"
            disabled={selectedRows.length === 0} // Disable jika tidak ada baris yang dipilih
          >
            Delete
          </Button> */}

          {/* Filter Button */}
          <Button
            startIcon={<FilterList />}
            variant="text"
            onClick={() => setOpenFilterDialog(true)}
          >
            Filters
          </Button>

          <Button
            startIcon={<Download />}
            variant="contained"
            className="exportButton"
            onClick={handleExport}
          >
            Export
          </Button>

          <Button
            startIcon={<Add />}
            variant="contained"
            className="addCategoryButton"
            onClick={() => handleOpenAddDialog()}
          >
            Add New Role
          </Button>
        </Box>
      </Box>

      {/* Delete Button & Subtitle */}
      {/* <Box className="deleteContainer">
        <IconButton
          onClick={() => setOpenDeleteDialog(true)}
          disabled={selectedRows.length === 0} // Disable jika tidak ada baris yang dipilih
          className="deleteButton"
        >
          <TrashOutline color={"#333"} height="20px" width="20px" />
        </IconButton>
      </Box> */}

      <Box className="deleteContainer">
        <Typography variant="body2" className="detailsSubtitle">
          Details List Of Role
        </Typography>
      </Box>

      {/* Delete Confirmation Dialog */}
      {/* <Dialog open={openDeleteDialog} onClose={() => setOpenDeleteDialog(false)}>
        <DialogTitle>Delete Rows?</DialogTitle>
        <DialogContent>
          <DialogContentText>Are you sure you want to delete the selected rows?</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenDeleteDialog(false)}>Cancel</Button>
          <Button onClick={handleDeleteRole} color="error">Delete</Button>
        </DialogActions>
      </Dialog> */}

      {/* Table */}
      <TableContainer component={Paper} className="tableContainer">
        <Table className="table">
          <TableHead className="tableHead">
            <TableRow>
              {/* <TableCell padding="checkbox" className="tableCell">
                <Checkbox
                  indeterminate={
                    selectedRows.length > 0 && selectedRows.length < rows.length
                  }
                  checked={selectedRows.length === rows.length}
                  onChange={() =>
                    setSelectedRows(
                      selectedRows.length === rows.length
                        ? []
                        : rows.map((row) => row.id)
                    )
                  }
                />
              </TableCell> */}
              <TableCell className="tableCell" width="50px">
                <strong>No</strong>
              </TableCell>
              <TableCell
                className="tableCell"
                onClick={() => handleSort("name")}
                style={{ cursor: "pointer" }}
              >
                <strong>Role Name</strong>
                {sortConfig.orderBy === "name" &&
                  (sortConfig.order === "asc" ? " ▲" : " ▼")}
              </TableCell>
              <TableCell
                className="tableCell"
                onClick={() => handleSort("description")}
                style={{ cursor: "pointer" }}
              >
                <strong>Description</strong>
                {sortConfig.orderBy === "description" &&
                  (sortConfig.order === "asc" ? " ▲" : " ▼")}
              </TableCell>
              <TableCell className="tableCell"></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {isLoading ? (
              <TableRow>
                <TableCell colSpan={3} align="center">
                  Loading...
                </TableCell>
              </TableRow>
            ) : (
              rows.map((row, index) => (
                <TableRow
                  key={row.name}
                  // selected={selectedRole?.name === row.name}
                  // onClick={(event) => handleRowClick(event, row.boldText)}
                  // style={{ cursor: "pointer" }}
                >
                  {/* <TableCell padding="checkbox" className="tableCell">
                    <Checkbox
                      checked={selectedRows.includes(row.id)}
                      onChange={(event) => {
                        event.stopPropagation();
                        handleSelectRow(row.id);
                      }}
                    />
                  </TableCell> */}
                  <TableCell>
                    {/* Nomor urut disesuaikan dengan pagination */}
                    {offset + index + 1}
                  </TableCell>
                  <TableCell className="tableCell">
                    <strong>{row.boldText}</strong>
                  </TableCell>
                  <TableCell className="tableCell">{row.textColumn1}</TableCell>
                  <TableCell className="tableCell">
                    <IconButton
                      onClick={(e) => {
                        e.stopPropagation();
                        handleOpenEditDialog(row.boldText);
                      }}
                    >
                      <MoreVert />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </TableContainer>

      {/* Pagination */}
      <Box
        className="paginationContainer"
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          width: "100%",
          padding: "16px 0",
        }}
      >
        {/* Info jumlah data */}
        <Typography variant="body2" sx={{ color: "text.secondary" }}>
          {`Showing ${offset + 1} to ${Math.min(
            offset + rowsPerPage,
            totalItems
          )} of ${totalItems} entries`}
        </Typography>

        {/* Komponen Pagination */}
        <Pagination
          count={totalPages}
          page={currentPage}
          onChange={(e, page) => setCurrentPage(page)}
          className="pagination"
          showFirstButton
          showLastButton
          renderItem={(item) => (
            <PaginationItem
              {...item}
              components={{ first: FirstPage, last: LastPage }}
            />
          )}
        />
      </Box>

      {/* ======================= Filter Dialog ============================= */}
      <Dialog
        open={openFilterDialog}
        onClose={() => setOpenFilterDialog(false)}
      >
        <DialogTitle>Advanced Search</DialogTitle>
        <DialogContent>
          {filters.map((filter, index) => {
            const usedFields = filters
              .map((f, i) => i !== index && f.field)
              .filter(Boolean);
            const availableOptions = availableFilters.filter(
              (opt) => !usedFields.includes(opt.value)
            );

            return (
              <Box
                key={index}
                display="flex"
                alignItems="center"
                gap={1}
                mb={2}
              >
                <TextField
                  select
                  value={filter.field}
                  onChange={(e) =>
                    handleFilterChange(index, "field", e.target.value)
                  }
                  variant="outlined"
                  size="small"
                  sx={{ mt: 1, minWidth: 160 }}
                >
                  {availableOptions.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))}
                </TextField>

                <TextField
                  label="Value"
                  variant="outlined"
                  size="small"
                  value={filter.value}
                  onChange={(e) =>
                    handleFilterChange(index, "value", e.target.value)
                  }
                  sx={{ mt: 1 }}
                />

                {index > 0 && (
                  <IconButton onClick={() => handleRemoveFilter(index)}>
                    <Remove />
                  </IconButton>
                )}
              </Box>
            );
          })}

          {filters.length < availableFilters.length && (
            <Button startIcon={<Add />} onClick={handleAddFilter}>
              Add Filter
            </Button>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleResetFilters}>Reset Filter</Button>
          <Button onClick={handleCloseFilter}>Cancel</Button>
          <Button
            variant="contained"
            onClick={handleApplyFilters}
            disabled={isLoading}
          >
            {isLoading ? "Loading..." : "Apply"}
          </Button>
        </DialogActions>
      </Dialog>

      {/* ============================= POPUP Add New Role ========================================= */}
      <Dialog
        open={openAddRoleDialog}
        onClose={() => setOpenAddRoleDialog(false)}
        fullWidth
        maxWidth="lg"
        sx={{ backdropFilter: "blur(5px)" }}
      >
        <DialogTitle
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography variant="h6" fontWeight="bold">
            Add New Role
          </Typography>
          <IconButton onClick={handleCloseAdd} color="error">
            <Close />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <Grid container spacing={3}>
            {/* Kolom 1: Nama Role dan Description */}
            <Grid item xs={12} md={6}>
              <Box
                sx={{ display: "flex", flexDirection: "column", gap: 2, mt: 2 }}
              >
                <TextField
                  fullWidth
                  label="Nama Role"
                  value={roleDataAdd.roleName}
                  name="roleName"
                  onChange={handleInputChangeAdd}
                  error={!roleDataAdd.roleName}
                  helperText={!roleDataAdd.roleName ? "Mandatory Field" : ""}
                />

                <Box>
                  <Typography
                    variant="body2"
                    color="textSecondary"
                    sx={{ mb: 1 }}
                  >
                    Role Description
                  </Typography>
                  <TextField
                    fullWidth
                    multiline
                    rows={4}
                    placeholder="Enter role description"
                    value={roleDataAdd.description}
                    name="description"
                    // error={!roleDataAdd.description}
                    // helperText={
                    //   !roleDataAdd.description ? "Mandatory Field" : ""
                    // }
                    onChange={handleInputChangeAdd}
                  />
                </Box>
              </Box>
            </Grid>

            {/* Kolom 2: Daftar Permission */}
            <Grid item xs={12} md={6}>
              <Box
                sx={{
                  border: "1px solid #e0e0e0",
                  borderRadius: 1,
                  p: 2,
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <Typography
                  variant="body2"
                  color="textSecondary"
                  sx={{ mb: 2 }}
                >
                  Permission List
                </Typography>

                <Box
                  sx={{
                    flexGrow: 1,
                    maxHeight: 200,
                    overflowY: "auto",
                    mb: 2,
                    p: 1,
                    backgroundColor: "#f9f9f9",
                    borderRadius: 1,
                  }}
                >
                  {roleDataAdd.permissions?.length > 0 ? (
                    roleDataAdd.permissions.map((permissionId, index) => {
                      const permission = permissionOptions.find(
                        (p) => p.value === permissionId
                      );
                      return (
                        <Box
                          key={index}
                          sx={{ display: "flex", alignItems: "center", mb: 1 }}
                        >
                          <Chip
                            label={permission?.label || permissionId}
                            onDelete={() => handleRemovePermission(index)}
                            sx={{
                              flexGrow: 1,
                              "& .MuiChip-label": {
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                              },
                            }}
                          />
                        </Box>
                      );
                    })
                  ) : (
                    <Typography
                      variant="body2"
                      color="text.disabled"
                      sx={{ textAlign: "center", py: 2 }}
                    >
                      No permissions added
                    </Typography>
                  )}
                </Box>

                <Box sx={{ display: "flex", gap: 1 }}>
                  <Select
                    fullWidth
                    displayEmpty
                    value={newPermission}
                    onChange={(e) => setNewPermission(e.target.value as string)}
                    size="small"
                    sx={{
                      flexGrow: 1,
                      "& .MuiOutlinedInput-root": {
                        borderRadius: 1,
                      },
                    }}
                    disabled={loadingPermissions}
                    MenuProps={{
                      PaperProps: {
                        style: {
                          maxHeight: 300,
                        },
                      },
                      disableEnforceFocus: true,
                      onKeyDown: (e) => {
                        if (
                          document.activeElement.id ===
                          "permission-search-input"
                        ) {
                          e.stopPropagation();
                        }
                      },
                    }}
                    onOpen={() => {
                      setTimeout(() => {
                        const searchInput = document.getElementById(
                          "permission-search-input"
                        );
                        if (searchInput) {
                          searchInput.focus();
                        }
                      }, 100);
                    }}
                  >
                    {/* Search Field */}
                    <Box sx={{ p: 1 }} onClick={(e) => e.stopPropagation()}>
                      <TextField
                        id="permission-search-input"
                        fullWidth
                        variant="outlined"
                        placeholder="Search permissions..."
                        value={permissionSearch}
                        onChange={(e) => setPermissionSearch(e.target.value)}
                        onClick={(e) => {
                          e.stopPropagation();
                          e.currentTarget.focus();
                        }}
                        onKeyDown={(e) => e.stopPropagation()}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <Search fontSize="small" />
                            </InputAdornment>
                          ),
                          endAdornment: permissionSearch && (
                            <InputAdornment position="end">
                              <IconButton
                                size="small"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  setPermissionSearch("");
                                }}
                              >
                                <Clear fontSize="small" />
                              </IconButton>
                            </InputAdornment>
                          ),
                          size: "small",
                        }}
                        sx={{
                          "& .MuiOutlinedInput-root": {
                            paddingRight: 1,
                          },
                        }}
                        autoFocus
                      />
                    </Box>

                    {/* Filtered Permission List */}
                    {permissionOptions
                      .filter(
                        (option) =>
                          !roleDataAdd.permissions.includes(option.value) &&
                          (option.label
                            .toLowerCase()
                            .includes(permissionSearch.toLowerCase()) ||
                            option.value
                              .toLowerCase()
                              .includes(permissionSearch.toLowerCase()))
                      )
                      .map((option) => (
                        <MenuItem key={option.value} value={option.value}>
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              gap: 1,
                            }}
                          >
                            <Typography>{option.label}</Typography>
                          </Box>
                        </MenuItem>
                      ))}

                    {permissionOptions.filter(
                      (option) =>
                        !roleDataAdd.permissions.includes(option.value) &&
                        (option.label
                          .toLowerCase()
                          .includes(permissionSearch.toLowerCase()) ||
                          option.value
                            .toLowerCase()
                            .includes(permissionSearch.toLowerCase()))
                    ).length === 0 && (
                      <MenuItem disabled>
                        <Typography variant="body2" color="text.secondary">
                          No permissions found
                        </Typography>
                      </MenuItem>
                    )}
                  </Select>
                  <Button
                    variant="contained"
                    onClick={handleAddPermission}
                    disabled={!newPermission}
                    size="small"
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      lineHeight: "1.2",
                      py: 0.5,
                      minHeight: "unset",
                    }}
                  >
                    <span>Add</span>
                    <span>Permission</span>
                  </Button>
                </Box>
              </Box>
            </Grid>
          </Grid>
        </DialogContent>

        {/* Buttons: Save & Close */}
        <DialogActions
          sx={{ display: "flex", justifyContent: "space-between", mt: 2 }}
        >
          <Button variant="outlined" color="error" onClick={handleCloseAdd}>
            Cancel
          </Button>
          <Button variant="contained" color="success" onClick={handleSaveAdd}>
            Save
          </Button>
        </DialogActions>
      </Dialog>

      {/* ==================================== POPUP Edit Role ======================================*/}
      <Dialog
        open={openEditRoleDialog}
        onClose={() => setOpenEditRoleDialog(false)}
        fullWidth
        maxWidth="sm"
        sx={{
          backdropFilter: "blur(5px)",
          "& .MuiDialog-paper": {
            borderRadius: 3,
            boxShadow: "0 8px 32px rgba(0,0,0,0.1)",
          },
        }}
      >
        <DialogTitle
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            backgroundColor: "white",
            color: "text.primary",
            py: 2,
            px: 3,
            borderBottom: "1px solid",
            borderColor: "divider",
            boxShadow: "0 2px 4px rgba(0,0,0,0.05)",
          }}
        >
          <Typography variant="h6" fontWeight="bold">
            {roleDataEdit.roleName}
          </Typography>
          <IconButton
            onClick={handleCloseEdit}
            sx={{
              color: "error",
              "&:hover": {
                backgroundColor: "action.hover",
              },
            }}
          >
            <Close />
          </IconButton>
        </DialogTitle>

        <DialogContent sx={{ p: 3 }}>
          <Box
            sx={{
              border: "1px solid",
              borderColor: "divider",
              borderRadius: 2,
              p: 2,
              height: "100%",
              display: "flex",
              flexDirection: "column",
              gap: 2,
              mt: 2,
            }}
          >
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <Typography
                variant="subtitle1"
                fontWeight="bold"
                color="text.secondary"
              >
                Assigned Permissions
              </Typography>
              {isEditing && (
                <Typography variant="caption" color="text.secondary">
                  {roleDataEdit.permissions?.length || 0} permissions
                </Typography>
              )}
            </Box>

            <Box
              sx={{
                flexGrow: 1,
                maxHeight: 300,
                overflowY: "auto",
                p: 1,
                backgroundColor: "background.default",
                borderRadius: 1,
                border: "1px solid",
                borderColor: "divider",
                minHeight: 100,
              }}
            >
              {roleDataEdit.permissions?.length > 0 ? (
                <Grid container spacing={1}>
                  {roleDataEdit.permissions.map((permissionId, index) => {
                    const permission = permissionOptions.find(
                      (p) => p.value === permissionId
                    );
                    return (
                      <Grid item xs={12} sm={6} key={index}>
                        <Chip
                          label={permission?.label || permissionId}
                          onDelete={
                            isEditing
                              ? () => handleRemovePermissionEdit(index)
                              : undefined
                          }
                          sx={{
                            width: "100%",
                            justifyContent: "space-between",
                            borderRadius: 1,
                            backgroundColor: isEditing
                              ? "action.selected"
                              : "background.paper",
                            "& .MuiChip-deleteIcon": {
                              color: "error.main",
                            },
                          }}
                          clickable={!isEditing}
                        />
                      </Grid>
                    );
                  })}
                </Grid>
              ) : (
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    height: 100,
                    color: "text.disabled",
                  }}
                >
                  <Typography variant="body2">
                    No permissions assigned
                  </Typography>
                  {!isEditing && (
                    <Typography variant="caption">
                      Click EDIT to add permissions
                    </Typography>
                  )}
                </Box>
              )}
            </Box>

            {isEditing && (
              <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
                <Select
                  fullWidth
                  displayEmpty
                  value={newPermission}
                  onChange={(e) => setNewPermission(e.target.value as string)}
                  size="small"
                  sx={{
                    flexGrow: 1,
                    "& .MuiOutlinedInput-root": {
                      borderRadius: 1,
                    },
                  }}
                  disabled={loadingPermissions}
                  MenuProps={{
                    PaperProps: {
                      style: {
                        maxHeight: 300,
                      },
                    },
                    disableEnforceFocus: true,
                    onKeyDown: (e) => {
                      if (
                        document.activeElement?.id ===
                        "permission-search-input-edit"
                      ) {
                        e.stopPropagation();
                      }
                    },
                  }}
                  onOpen={() => {
                    setTimeout(() => {
                      const searchInput = document.getElementById(
                        "permission-search-input-edit"
                      );
                      if (searchInput) {
                        searchInput.focus();
                      }
                    }, 100);
                  }}
                >
                  {/* Search Field - Now fully interactive */}
                  <Box sx={{ p: 1 }} onClick={(e) => e.stopPropagation()}>
                    <TextField
                      id="permission-search-input-edit"
                      fullWidth
                      variant="outlined"
                      placeholder="Search permissions..."
                      value={permissionSearchEdit}
                      onChange={(e) => setPermissionSearchEdit(e.target.value)}
                      onClick={(e) => {
                        e.stopPropagation();
                        e.currentTarget.focus();
                      }}
                      onKeyDown={(e) => e.stopPropagation()}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <Search fontSize="small" />
                          </InputAdornment>
                        ),
                        endAdornment: permissionSearchEdit && (
                          <InputAdornment position="end">
                            <IconButton
                              size="small"
                              onClick={(e) => {
                                e.stopPropagation();
                                setPermissionSearchEdit("");
                              }}
                            >
                              <Clear fontSize="small" />
                            </IconButton>
                          </InputAdornment>
                        ),
                        size: "small",
                      }}
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          paddingRight: 1,
                        },
                      }}
                      autoFocus
                    />
                  </Box>

                  {/* Filtered Permission List */}
                  {permissionOptions
                    .filter(
                      (option) =>
                        !roleDataEdit.permissions.includes(option.value) &&
                        (option.label
                          .toLowerCase()
                          .includes(permissionSearchEdit.toLowerCase()) ||
                          option.value
                            .toLowerCase()
                            .includes(permissionSearchEdit.toLowerCase()))
                    )
                    .map((option) => (
                      <MenuItem key={option.value} value={option.value}>
                        <Box
                          sx={{ display: "flex", alignItems: "center", gap: 1 }}
                        >
                          <Typography>{option.label}</Typography>
                        </Box>
                      </MenuItem>
                    ))}

                  {permissionOptions.filter(
                    (option) =>
                      !roleDataEdit.permissions.includes(option.value) &&
                      (option.label
                        .toLowerCase()
                        .includes(permissionSearchEdit.toLowerCase()) ||
                        option.value
                          .toLowerCase()
                          .includes(permissionSearchEdit.toLowerCase()))
                  ).length === 0 && (
                    <MenuItem disabled>
                      <Typography variant="body2" color="text.secondary">
                        No permissions found
                      </Typography>
                    </MenuItem>
                  )}
                </Select>
                <Button
                  variant="contained"
                  onClick={handleAddPermissionEdit}
                  disabled={!newPermission}
                  sx={{
                    minWidth: 120,
                    height: 40,
                    borderRadius: 1,
                    textTransform: "none",
                  }}
                >
                  Add
                </Button>
              </Box>
            )}
          </Box>
        </DialogContent>

        <DialogActions
          sx={{
            px: 3,
            py: 2,
            borderTop: "1px solid",
            borderColor: "divider",
          }}
        >
          {!isEditing ? (
            <Button
              onClick={() => setIsEditing(true)}
              variant="contained"
              color="primary"
              sx={{
                borderRadius: 1,
                px: 3,
                textTransform: "none",
                fontWeight: "bold",
              }}
            >
              Edit Permissions
            </Button>
          ) : (
            <>
              <Button
                onClick={() => setIsEditing(false)}
                variant="outlined"
                color="error"
                sx={{
                  borderRadius: 1,
                  px: 3,
                  textTransform: "none",
                }}
              >
                Cancel
              </Button>
              <Button
                onClick={handleSaveEdit}
                variant="contained"
                color="success"
                sx={{
                  borderRadius: 1,
                  px: 3,
                  textTransform: "none",
                  fontWeight: "bold",
                }}
              >
                Save Changes
              </Button>
            </>
          )}
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default RoleListPage;
